<template lang="pug">
	.asset-replace-not-allowed-popup(v-if="showed && Creative.SelectedCreative && Version.SelectedVersion")
		.card
			.card-header
				.header-title
					i.fa.fa-upload
					span Replace asset is not allowed
				.close-button(@click="close()")
					i.fa.fa-close
			.card-body.collapse.show
				span You can't replace asset in base version
				button.btn.btn-primary(:disabled="!Version.canCopyVersion()" @click="duplicate" v-b-tooltip.hover.right="Version.canCopyVersion() ? {} : {delay: { show: 100, hide: 100 }, title: 'Duplicate creative version'}") Duplicate current version
				button.btn.btn-primary(:class="customVersions.length ? '' : 'not-allowed'" @click="goToCustom" v-b-tooltip.hover.right="customVersions.length ? {} : {delay: { show: 100, hide: 100 }, title: 'No custom versions found'}") Switch to existing custom version

</template>
<script>

	import Screen 				from './../../mixins/screen';

	import { Creative } 			from './../../services/Creative';
	import { Version } 			from './../../services/Version';

	export default {
		name: 'AssetReplaceNotAllowedPopUp',
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;

			return {
				customVersions: []
			}

		},
		methods: {
			collectData() {
				const creativeVersions = Version.getVersionsByCreative(Creative.SelectedCreative.id);
				this.customVersions = Object.values(creativeVersions).filter(version => !version.Tags.base);
				console.log(this.customVersions);
			},
			duplicate() {

				if (!Version.canCopyVersion()) return;

				Broadcast.call("Show VersionDuplicate");
				this.hide();

			},
			goToCustom() {
				if (!this.customVersions.length) return;
				Version.selectVersion(this.customVersions[0].id);
				this.hide();
			},
			close() {
				this.hide();
			}
		}
	}
</script>
<style lang="sass">
	.app > .asset-replace-not-allowed-popup
		position: absolute
		z-index: 1060
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		display: flex

		.card
			font-size: 16px
			width: 400px
			position: relative
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			border-top: 3px solid var(--warning)
			//color: var(--warning)

			.card-header
				display: flex
				flex-direction: row
				justify-content: space-between
				color: var(--warning)

				.close-button
					display: flex
					font-size: 25px
					opacity: 0.3
					cursor: pointer
					align-items: center

					&:hover
						opacity: 1

			.card-body
				display: flex
				flex-direction: column
				gap: 10px

				button

					font-size: 16px

					&.not-allowed
						cursor: not-allowed
						opacity: 0.65

</style>
